export default __webpack_public_path__ + "static/media/mines.b7339598.jpg";